/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statsinvitescaption2Inputs */

const en_statsinvitescaption2 = /** @type {(inputs: Statsinvitescaption2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invites (7 days)`)
};

const de_statsinvitescaption2 = /** @type {(inputs: Statsinvitescaption2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einladungen (7 Tage)`)
};

/**
* | output |
* | --- |
* | "Invites (7 days)" |
*
* @param {Statsinvitescaption2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsinvitescaption2 = /** @type {((inputs?: Statsinvitescaption2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsinvitescaption2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsinvitescaption2(inputs)
	return de_statsinvitescaption2(inputs)
});
export { statsinvitescaption2 as "statsInvitesCaption" }